import { HttpEvent, HttpProgressEvent, HttpResponse, HttpSentEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentClientService } from '../client/document-client.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentManagerService {
    private readonly clientService = inject(DocumentClientService);

    uploadDocument(guid: string, file: File, comment: string): Observable<HttpEvent<HttpSentEvent | HttpProgressEvent | HttpResponse<string>>> {
        return this.clientService.uploadDocument(guid, file, comment);
    }

    getDocumentById(documentId: string): Observable<Blob> {
        return this.clientService.getDocumentById(documentId);
    }
}
